import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import AdminLayout from '../components/AdminLayout.jsx';
import { api } from '../../api/client.js';
import { Swal2 } from '../../lib/swal.js';
import { MORPH_BTN_SM } from '../../lib/ui.js';

export default function LayananList() {
  const [items, setItems] = useState(null);

  const load = () => api.get('/admin/layanan').then(({ data }) => setItems(data.items));
  useEffect(() => { load(); }, []);

  const remove = async (item) => {
    const confirmed = await Swal2.confirmDelete(item.nama);
    if (!confirmed) return;
    await api.delete(`/admin/layanan/${item.id}`);
    Swal2.toast('success', 'Layanan berhasil dihapus.');
    load();
  };

  return (
    <AdminLayout title="Kelola Layanan">
      <div className="flex justify-end mb-4">
        <Link to="/admin/layanan/new" className={`inline-flex items-center gap-2 px-5 py-2.5 rounded-xl font-bold text-white text-sm ${MORPH_BTN_SM}`} style={{ background: 'var(--accent)' }}>
          <span className="material-symbols-outlined text-base">add</span> Tambah Layanan
        </Link>
      </div>

      <div className="rounded-2xl border bg-white dark:bg-neutral-900 border-black/5 dark:border-white/5 overflow-hidden">
        <div className="overflow-x-auto">
        <table className="w-full min-w-[640px] text-sm">
          <thead className="bg-neutral-50 dark:bg-neutral-800 text-left text-xs uppercase text-neutral-500">
            <tr>
              <th className="px-4 py-3">Icon</th>
              <th className="px-4 py-3">Nama</th>
              <th className="px-4 py-3">Target</th>
              <th className="px-4 py-3">Urutan</th>
              <th className="px-4 py-3">Status</th>
              <th className="px-4 py-3 text-right">Aksi</th>
            </tr>
          </thead>
          <tbody>
            {items === null && <tr><td colSpan={6} className="px-4 py-6 text-neutral-400">Memuat...</td></tr>}
            {items?.length === 0 && <tr><td colSpan={6} className="px-4 py-6 text-neutral-400">Belum ada layanan.</td></tr>}
            {items?.map((item) => (
              <tr key={item.id} className="border-t border-neutral-100 dark:border-neutral-800">
                <td className="px-4 py-3"><span className="material-symbols-outlined text-forest-500">{item.icon}</span></td>
                <td className="px-4 py-3 font-semibold text-neutral-900 dark:text-white">
                  <span className="flex items-center gap-2 whitespace-nowrap">
                    {item.nama}
                    {item.sub_layanan?.length > 0 && (
                      <span className="text-[10px] font-bold px-1.5 py-0.5 rounded-full bg-blue-50 text-blue-600 dark:bg-blue-500/10 dark:text-blue-400">
                        {item.sub_layanan.length} sub
                      </span>
                    )}
                  </span>
                </td>
                <td className="px-4 py-3 text-neutral-500 dark:text-neutral-400 max-w-xs truncate">{item.target_audience}</td>
                <td className="px-4 py-3 text-neutral-500">{item.sort_order}</td>
                <td className="px-4 py-3">
                  <span className={`text-xs font-bold px-2 py-0.5 rounded-full whitespace-nowrap ${item.is_active ? 'bg-forest-500/10 text-forest-500' : 'bg-neutral-100 text-neutral-400 dark:bg-neutral-800'}`}>
                    {item.is_active ? 'Aktif' : 'Nonaktif'}
                  </span>
                </td>
                <td className="px-4 py-3 text-right space-x-2 whitespace-nowrap">
                  <Link to={`/admin/layanan/${item.id}/edit`} className={`text-xs font-semibold px-3 py-1.5 rounded-lg bg-neutral-100 dark:bg-neutral-800 text-neutral-600 dark:text-white ${MORPH_BTN_SM}`}>Edit</Link>
                  <button onClick={() => remove(item)} className={`text-xs font-semibold px-3 py-1.5 rounded-lg bg-red-50 text-red-500 dark:bg-red-950/30 ${MORPH_BTN_SM}`}>Hapus</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
        </div>
      </div>
      <p className="md:hidden text-center text-[11px] text-neutral-400 mt-2 flex items-center justify-center gap-1">
        <span className="material-symbols-outlined text-sm">swipe</span> Geser tabel ke kiri/kanan untuk lihat semua kolom
      </p>
    </AdminLayout>
  );
}
